import { RenderPass } from "@/core/pipeline/render-pass"
import { OutputColorSpace, RenderColorSpace } from "@/core/types"
import { Texture } from "@/core/backends/webgl/texture"

export class DisplayOutputPass extends RenderPass {
	render(
		input: Texture,
		output?: Texture,
		options?: {
			outputColorSpace?: RenderColorSpace
			showHighlightsClipping?: boolean
			showShadowsClipping?: boolean
			enableDither?: boolean
		},
	) {
		const { renderer } = this

		renderer.setRenderTarget(output)

		input.bind(0)

		// Output color space
		let outputColorSpace: OutputColorSpace

		switch (options?.outputColorSpace) {
			case "srgb":
				outputColorSpace = OutputColorSpace.sRGB
				break
			case "display-p3":
				outputColorSpace = OutputColorSpace.displayP3
				break
			case "gamma":
				outputColorSpace = OutputColorSpace.gamma
				break
			default:
				outputColorSpace = OutputColorSpace.displayP3
				break
		}

		if (outputColorSpace == OutputColorSpace.gamma) {
			renderer.shaders.gamma.render({ inputTexture: 0 })
		} else {
			renderer.alphaTexture.bind(1)
			renderer.shaders.displayOutput.render({
				inputTexture: 0,
				alphaTexture: 1,
				outputColorSpace,
				showHighlightsClipping: options?.showHighlightsClipping ?? false,
				showShadowsClipping: options?.showShadowsClipping ?? false,
				enableDither: options?.enableDither ?? false,
			})
		}
	}

	dispose() {
		return
	}
}
